import React from 'react'
import Label from "components/general/Label"
import { ColumnStartOrder, ColumnName, ColumnNoc, ColumnExpander, ColumnWarnings, ColumnQualification, ColumnRecords } from "components/common/TableColumns"
import { findArray } from 'helpers/utils'
import { ColumnIntermediateRank } from "components/common/TableColumnsIntermediates"







export function TableColumns(columnsAdded) {

    const getHeader = (extendedInfos, relay) => {
        const intermediate = extendedInfos?.find(ei => ei?.ei_code === 'INTERMEDIATE' && ei?.ei_pos === relay + '')?.ei_value;
        return intermediate && !isNaN(intermediate) ? <>{intermediate}m</> : <><Label data={'HeaderFinish'} /></>
    }

    //Create Columns splits
    let columnsExt = []
    for (let relay = 1; relay <= 4; relay++) {
        columnsExt.push(
            {
                Header: getHeader(columnsAdded, relay),
                accessor: (row) => {

                    let val = findArray(row?.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [relay.toString()] }).er_sortorder
                    let valSortOrderSplit = val ? val : Number(row.sortOrder) + 500


                    return (
                        row.resultType !== 'IRM' ? valSortOrderSplit : Number(row.sortOrder) + 1000
                    )
                },
                sortType: "absoluteOrderNumber",
                disableSortBy: false,
                isVisible: false,
                columnIndex: relay,
                id: 'ResultEx' + relay,
                className: 'text-end',
                headerClassName: 'text-end w-10',
                Cell: (props) => {
                    let res = findArray(props.cell.row.original?.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [relay.toString()] })
                    return (
                        res.er_rank ? <>{res.er_value}({res.er_rank})</> : <>{res.er_value}</>
                    )
                }

            }
        )
    }

    return (
        [

            ColumnIntermediateRank({}),
            ColumnStartOrder({ label: 'HeaderLane' }),
            ColumnNoc({}),
            ColumnName({ label: 'HeaderTeam' }),
            ColumnWarnings({}),
            {
                Header: <Label data='HeaderReaction' />,
                accessor: 'extendedResults',
                className: 'text-end',
                headerClassName: 'text-end w-5',
                id: 'RactionTime',
                Cell: (props) => (
                    props.cell.row.original.extendedResults
                        ? props.cell.row.original.extendedResults.filter(row => row.er_code === 'REACT_TIME').map((val) => { return (val.er_value) })
                        : ''
                )
            },
            ...columnsExt,
            ColumnRecords({}),
            ColumnQualification({}),
            ColumnExpander({ type: 'alwaysTrue2' })

        ]
    )
}

export default TableColumns
